import { render } from "./ExpiredHygieneCert.vue?vue&type=template&id=cfa33d40&scoped=true"
import script from "./ExpiredHygieneCert.vue?vue&type=script&lang=js"
export * from "./ExpiredHygieneCert.vue?vue&type=script&lang=js"

import "./ExpiredHygieneCert.vue?vue&type=style&index=0&id=cfa33d40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa33d40"]])

export default __exports__